(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9994],{

/***/ 56227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ BackButtonBar; },
/* harmony export */   "x": function() { return /* binding */ BackButton; }
/* harmony export */ });
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91289);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40774);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71345);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var BackButtonBar = function BackButtonBar(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      buttonClassName = _ref.buttonClassName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    "data-navigate-row": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackButton, {
      onClick: onClick,
      className: buttonClassName
    })
  });
};
var BackButton = function BackButton(_ref2) {
  var onClick = _ref2.onClick,
      className = _ref2.className;
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .q)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
    "data-navigate-item": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().back), className),
    onClick: onClick,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      children: t("back")
    })]
  });
};

/***/ }),

/***/ 40774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M50 27.5H19.575L33.55 13.525 30 10 10 30l20 20 3.525-3.525L19.575 32.5H50v-5z",
      fill: "#fff"
    })
  }));
};

var MemoArrowBack = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ArrowBack);
/* harmony default export */ __webpack_exports__["Z"] = (MemoArrowBack);

/***/ }),

/***/ 20701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Globe = function Globe(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zM3.333 10c0-.508.067-1.008.175-1.483L7.492 12.5v.833c0 .917.75 1.667 1.666 1.667v1.608C5.883 16.192 3.333 13.392 3.333 10zm9.992 3.333c.75 0 1.367.492 1.583 1.167a6.66 6.66 0 001.759-4.5 6.67 6.67 0 00-4.175-6.175v.341c0 .917-.75 1.667-1.667 1.667H9.158V7.5a.836.836 0 01-.833.833H6.658V10h5c.459 0 .834.375.834.833v2.5h.833z",
      fill: "#fff"
    })
  }));
};

var MemoGlobe = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Globe);
/* harmony default export */ __webpack_exports__["Z"] = (MemoGlobe);

/***/ }),

/***/ 9761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var HeartOutline = function HeartOutline(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 81 76",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#prefix__filter0_d_4529_10429)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("mask", {
        id: "prefix__a",
        fill: "#fff",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M55.151.25c-4.737 0-7.791.578-11.292 2.335a20.126 20.126 0 00-3.642 2.346 20.55 20.55 0 00-3.496-2.239C33.153.883 29.941.25 25.374.25 13.14.25 4.25 10.638 4.25 24.129c0 10.189 5.543 20.03 15.869 29.547 5.42 4.996 12.34 9.94 17.295 12.57l2.836 1.504 2.836-1.505c4.955-2.63 11.875-7.573 17.295-12.569C70.707 44.16 76.25 34.319 76.25 24.13 76.25 10.781 67.276.302 55.151.25z"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        clipRule: "evenodd",
        d: "M55.151.25c-4.737 0-7.791.578-11.292 2.335a20.126 20.126 0 00-3.642 2.346 20.55 20.55 0 00-3.496-2.239C33.153.883 29.941.25 25.374.25 13.14.25 4.25 10.638 4.25 24.129c0 10.189 5.543 20.03 15.869 29.547 5.42 4.996 12.34 9.94 17.295 12.57l2.836 1.504 2.836-1.505c4.955-2.63 11.875-7.573 17.295-12.569C70.707 44.16 76.25 34.319 76.25 24.13 76.25 10.781 67.276.302 55.151.25z",
        stroke: "#fff",
        strokeWidth: 14,
        strokeLinecap: "round",
        shapeRendering: "geometricPrecision",
        mask: "url(#prefix__a)"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "prefix__filter0_d_4529_10429",
        x: 0.25,
        y: 0.25,
        width: 80,
        height: 75.5,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_4529_10429"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_4529_10429",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoHeartOutline = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(HeartOutline);
/* harmony default export */ __webpack_exports__["Z"] = (MemoHeartOutline);

/***/ }),

/***/ 62735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ truncateString; }
/* harmony export */ });
var truncateString = function truncateString(text, maxLength) {
  if (text.length >= maxLength - 3) {
    return "".concat(text.substring(0, maxLength - 3).trim(), "...");
  }

  return text;
};

/***/ }),

/***/ 89404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ RadioPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./pages/radios/radio-details.module.scss
var radio_details_module = __webpack_require__(66795);
var radio_details_module_default = /*#__PURE__*/__webpack_require__.n(radio_details_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./app/components/radio-view/radio-view.module.scss
var radio_view_module = __webpack_require__(32144);
var radio_view_module_default = /*#__PURE__*/__webpack_require__.n(radio_view_module);
// EXTERNAL MODULE: ./app/components/icons/Pause.tsx
var Pause = __webpack_require__(82334);
// EXTERNAL MODULE: ./app/components/icons/Play.tsx
var Play = __webpack_require__(43935);
// EXTERNAL MODULE: ./app/components/icons/HeartOutline.tsx
var HeartOutline = __webpack_require__(9761);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./app/store/slices/player.ts
var player = __webpack_require__(22564);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./app/components/icons/Logo.tsx
var Logo = __webpack_require__(23583);
// EXTERNAL MODULE: ./app/hooks/favorites.hook.ts
var favorites_hook = __webpack_require__(18958);
// EXTERNAL MODULE: ./app/components/icons/HeartFull.tsx
var HeartFull = __webpack_require__(1919);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 21 modules
var format = __webpack_require__(19802);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
// EXTERNAL MODULE: ./app/store/slices/radio.ts
var slices_radio = __webpack_require__(49624);
// EXTERNAL MODULE: ./app/components/icons/Globe.tsx
var Globe = __webpack_require__(20701);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/components/icons/AngleDown.tsx
var AngleDown = __webpack_require__(37526);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(43337);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/radio-view/radio-view.component.tsx



























var RadioTabs;

(function (RadioTabs) {
  RadioTabs["Live"] = "Live";
  RadioTabs["Schedule"] = "Schedule";
  RadioTabs["Podcasts"] = "Podcasts";
})(RadioTabs || (RadioTabs = {}));

var RadioView = function RadioView(_ref) {
  var _playerState$activeMe, _playerState$activeMe2, _playerState$activeMe5, _playerState$activeMe6, _clsx, _historyData$data, _historyData$data$bod, _historyData$data$bod2, _historyData$data2, _historyData$data2$bo, _historyData$data2$bo2, _scheduleData$pages, _scheduleData$pages$, _scheduleData$pages$$, _scheduleData$pages$$2, _scheduleData$pages$$3, _scheduleData$pages$2, _scheduleData$pages$3, _scheduleData$pages$4, _scheduleData$pages$5, _radioPodcastsData$pa, _radioPodcastsData$pa2, _radioPodcastsData$pa3, _radioPodcastsData$pa4, _radioPodcastsData$pa5, _radioPodcastsData$pa6, _radioPodcastsData$pa7, _radioPodcastsData$pa8, _radioPodcastsData$pa9;

  var radio = _ref.radio;

  var _useAppSelector = (0,store/* useAppSelector */.CG)(slices_radio/* selectRadioState */.K_),
      activeSection = _useAppSelector.activeSection,
      activeIndex = _useAppSelector.activeIndex;

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled,
      setIsPlaying = _usePlayerContext.setIsPlaying,
      isMediaLoading = _usePlayerContext.isMediaLoading,
      isPlaying = _usePlayerContext.isPlaying,
      setFullscreenPlayerInitialyOpen = _usePlayerContext.setFullscreenPlayerInitialyOpen;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      showRadioWebsite = _useFeaturesContext.showRadioWebsite;

  var dispatch = (0,store/* useAppDispatch */.TL)();
  var playerState = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA); //TODO Add handling of missing liveData (show message instead of play button)

  var _useGetPillowRadioLiv = (0,hooks/* useGetPillowRadioLive */.pE)(radio.permalink, {
    isPlaying: ((_playerState$activeMe = playerState.activeMedia) === null || _playerState$activeMe === void 0 ? void 0 : (_playerState$activeMe2 = _playerState$activeMe.category) === null || _playerState$activeMe2 === void 0 ? void 0 : _playerState$activeMe2.permalink) === radio.permalink
  }),
      liveData = _useGetPillowRadioLiv.data,
      isLoading = _useGetPillowRadioLiv.isLoading;

  var _useGetPillowRadioPod = (0,hooks/* useGetPillowRadioPodcasts */.hz)(radio.permalink, {
    page: 1,
    pageSize: 100
  }),
      radioPodcastsData = _useGetPillowRadioPod.data,
      radioPodcastsLoading = _useGetPillowRadioPod.isLoading;

  var _useGetPillowRadioHis = (0,hooks/* useGetPillowRadioHistory */.bF)(radio.permalink),
      historyData = _useGetPillowRadioHis.data,
      historyLoading = _useGetPillowRadioHis.isLoading,
      refetchHistory = _useGetPillowRadioHis.refetch;

  var _useGetPillowRadioSch = (0,hooks/* useGetPillowRadioSchedulesToday */.y2)(radio.permalink, {
    page: 1,
    pageSize: 100
  }),
      scheduleData = _useGetPillowRadioSch.data,
      scheduleLoading = _useGetPillowRadioSch.isLoading;

  var _useState = (0,react.useState)(RadioTabs.Podcasts),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var _useFavorites = (0,favorites_hook/* useFavorites */.r)(),
      toggleFavorite = _useFavorites.toggleFavorite,
      loading = _useFavorites.loading,
      isFavoriteCategory = _useFavorites.isFavoriteCategory;

  var t = (0,lang/* useTranslate */.q)();

  var _useState2 = (0,react.useState)(false),
      descriptionExpandable = _useState2[0],
      setDescriptionExpandable = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      descriptionExpanded = _useState3[0],
      setDescriptionExpanded = _useState3[1];

  var descriptionContainerRef = (0,react.useRef)(null);
  var descriptionRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var _descriptionContainer, _descriptionRef$curre;

    var containerHeight = ((_descriptionContainer = descriptionContainerRef.current) === null || _descriptionContainer === void 0 ? void 0 : _descriptionContainer.clientHeight) || 0;
    var descriptionHeight = ((_descriptionRef$curre = descriptionRef.current) === null || _descriptionRef$curre === void 0 ? void 0 : _descriptionRef$curre.clientHeight) || 0;

    if (containerHeight > 0 && descriptionHeight > 0) {
      if (containerHeight < descriptionHeight) {
        setDescriptionExpandable(true);
      }
    }
  }, [radio.description]);

  var startLivePlayback = function startLivePlayback() {
    var _playerState$activeMe3, _playerState$activeMe4;

    setFullscreenPlayerInitialyOpen(true);
    setPlayerEnabled(true);

    if ((playerState === null || playerState === void 0 ? void 0 : (_playerState$activeMe3 = playerState.activeMedia) === null || _playerState$activeMe3 === void 0 ? void 0 : (_playerState$activeMe4 = _playerState$activeMe3.category) === null || _playerState$activeMe4 === void 0 ? void 0 : _playerState$activeMe4.permalink) !== (radio === null || radio === void 0 ? void 0 : radio.permalink)) {
      dispatch(player/* playerActions.selectTrack */.i9.selectTrack({
        category: radio,
        podcast: null
      }));
    } else {
      setIsPlaying(true);
    }

    if (activeSection[activeIndex] && activeSection[activeIndex].permalink === radio.permalink) {
      dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
        items: activeSection,
        activeIndex: activeIndex
      }));
    } else {
      dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
        items: [radio],
        activeIndex: 0
      }));
    }
  };

  var stopPlayback = function stopPlayback() {
    setIsPlaying(false);
  };

  var addToFavourites = function addToFavourites() {
    toggleFavorite(radio);
  };

  var formatScheduleTime = function formatScheduleTime(start, end) {
    return "".concat((0,format/* default */.Z)((0,parseISO/* default */.Z)(start), "HH:mm"), " - ").concat((0,format/* default */.Z)((0,parseISO/* default */.Z)(end), "HH:mm"));
  }; // refresh history


  (0,useInterval/* default */.Z)(function () {
    if (activeTab === RadioTabs.Live) {
      refetchHistory();
    }
  }, 30000);
  (0,react.useEffect)(function () {
    if (activeTab === RadioTabs.Live) {
      refetchHistory();
    }
  }, [activeTab]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (radio_view_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (radio_view_module_default()).podcast_cover,
      children: [radio !== null && radio !== void 0 && radio.logo || radio !== null && radio !== void 0 && radio.smallLogo ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: (radio === null || radio === void 0 ? void 0 : radio.logo) || (radio === null || radio === void 0 ? void 0 : radio.smallLogo),
        alt: radio === null || radio === void 0 ? void 0 : radio.name
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (radio_view_module_default()).no_image,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (radio_view_module_default()).podcast_details,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          children: radio === null || radio === void 0 ? void 0 : radio.name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (radio_view_module_default()).buttons_wrapper,
          "data-navigate-row": true,
          children: [isLoading || isMediaLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (radio_view_module_default()).action_button,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
          }) : ((_playerState$activeMe5 = playerState.activeMedia) === null || _playerState$activeMe5 === void 0 ? void 0 : (_playerState$activeMe6 = _playerState$activeMe5.category) === null || _playerState$activeMe6 === void 0 ? void 0 : _playerState$activeMe6.permalink) === radio.permalink && isPlaying ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            disabled: isLoading,
            className: (0,clsx_m/* default */.Z)((radio_view_module_default()).action_button, (radio_view_module_default()).play_button),
            onClick: stopPlayback,
            "data-navigate-item": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pause/* default */.Z, {})
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            disabled: isLoading,
            className: (0,clsx_m/* default */.Z)((radio_view_module_default()).action_button, (radio_view_module_default()).play_button),
            onClick: startLivePlayback,
            "data-navigate-item": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Play/* default */.Z, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (0,clsx_m/* default */.Z)((radio_view_module_default()).action_button, (radio_view_module_default()).favorites_button),
            onClick: addToFavourites,
            "data-navigate-item": true,
            children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : isFavoriteCategory(radio) ? /*#__PURE__*/(0,jsx_runtime.jsx)(HeartFull/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(HeartOutline/* default */.Z, {})
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (0,clsx_m/* default */.Z)((radio_view_module_default()).podcast_description_container, (_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (radio_view_module_default()).expanded, descriptionExpanded), (0,defineProperty/* default */.Z)(_clsx, (radio_view_module_default()).expandable, descriptionExpandable), _clsx)),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (radio_view_module_default()).podcast_description,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: radio === null || radio === void 0 ? void 0 : radio.baseline
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: descriptionContainerRef,
          className: (radio_view_module_default()).description_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            ref: descriptionRef,
            className: (radio_view_module_default()).description,
            children: radio === null || radio === void 0 ? void 0 : radio.description
          })
        })]
      }), descriptionExpandable && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-navigate-row": true,
        className: (0,clsx_m/* default */.Z)((radio_view_module_default()).expander, (0,defineProperty/* default */.Z)({}, (radio_view_module_default()).open, descriptionExpanded)),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          "data-navigate-item": true,
          onClick: function onClick() {
            return setDescriptionExpanded(function (value) {
              return !value;
            });
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AngleDown/* default */.Z, {})
        })
      }), showRadioWebsite && radio.web && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: radio.web,
        target: "_blank",
        rel: "noopener",
        "data-navigate-item": true,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          className: (radio_view_module_default()).website_button,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Globe/* default */.Z, {}), t("radio.visit-website")]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (radio_view_module_default()).tabs_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (radio_view_module_default()).tabs,
        "data-navigate-row": true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return setActiveTab(RadioTabs.Live);
          },
          className: (0,clsx_m/* default */.Z)((radio_view_module_default()).tab, (0,defineProperty/* default */.Z)({}, (radio_view_module_default()).active, activeTab === RadioTabs.Live)),
          "data-navigate-item": true,
          children: t("tabs.playlist")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return setActiveTab(RadioTabs.Podcasts);
          },
          className: (0,clsx_m/* default */.Z)((radio_view_module_default()).tab, (0,defineProperty/* default */.Z)({}, (radio_view_module_default()).active, activeTab === RadioTabs.Podcasts)),
          "data-navigate-item": true,
          children: t("tabs.podcasts")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return setActiveTab(RadioTabs.Schedule);
          },
          className: (0,clsx_m/* default */.Z)((radio_view_module_default()).tab, (0,defineProperty/* default */.Z)({}, (radio_view_module_default()).active, activeTab === RadioTabs.Schedule)),
          "data-navigate-item": true,
          children: t("tabs.schedule")
        })]
      })
    }), activeTab === RadioTabs.Live ? historyData !== null && historyData !== void 0 && (_historyData$data = historyData.data) !== null && _historyData$data !== void 0 && (_historyData$data$bod = _historyData$data.body) !== null && _historyData$data$bod !== void 0 && (_historyData$data$bod2 = _historyData$data$bod.content) !== null && _historyData$data$bod2 !== void 0 && _historyData$data$bod2.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (radio_view_module_default()).content_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (radio_view_module_default()).details_header,
          children: t("tabs.playlist")
        }), historyData === null || historyData === void 0 ? void 0 : (_historyData$data2 = historyData.data) === null || _historyData$data2 === void 0 ? void 0 : (_historyData$data2$bo = _historyData$data2.body) === null || _historyData$data2$bo === void 0 ? void 0 : (_historyData$data2$bo2 = _historyData$data2$bo.content) === null || _historyData$data2$bo2 === void 0 ? void 0 : _historyData$data2$bo2.map(function (historyItem, historyIndex) {
          var _historyItem$artist;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((radio_view_module_default()).live_track, (radio_view_module_default()).responsive),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: (radio_view_module_default()).live_track_logo,
              src: historyItem.cover && typeof historyItem.cover === "string" ? historyItem.cover : radio === null || radio === void 0 ? void 0 : radio.logo
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (radio_view_module_default()).live_track_body,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                children: historyItem === null || historyItem === void 0 ? void 0 : historyItem.name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                children: historyItem === null || historyItem === void 0 ? void 0 : (_historyItem$artist = historyItem.artist) === null || _historyItem$artist === void 0 ? void 0 : _historyItem$artist.name
              })]
            })]
          }, "history-item-".concat(historyIndex));
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (radio_view_module_default()).no_data,
      children: t("radio_playlist_message_noPlaylist")
    }) : null, activeTab === RadioTabs.Schedule ? scheduleData && scheduleData !== null && scheduleData !== void 0 && (_scheduleData$pages = scheduleData.pages) !== null && _scheduleData$pages !== void 0 && _scheduleData$pages.length && scheduleData !== null && scheduleData !== void 0 && (_scheduleData$pages$ = scheduleData.pages[0]) !== null && _scheduleData$pages$ !== void 0 && (_scheduleData$pages$$ = _scheduleData$pages$.data) !== null && _scheduleData$pages$$ !== void 0 && (_scheduleData$pages$$2 = _scheduleData$pages$$.body) !== null && _scheduleData$pages$$2 !== void 0 && (_scheduleData$pages$$3 = _scheduleData$pages$$2.content) !== null && _scheduleData$pages$$3 !== void 0 && _scheduleData$pages$$3.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (radio_view_module_default()).content_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: (radio_view_module_default()).details_header,
        children: t("tabs.schedule")
      }), scheduleData === null || scheduleData === void 0 ? void 0 : (_scheduleData$pages$2 = scheduleData.pages[0]) === null || _scheduleData$pages$2 === void 0 ? void 0 : (_scheduleData$pages$3 = _scheduleData$pages$2.data) === null || _scheduleData$pages$3 === void 0 ? void 0 : (_scheduleData$pages$4 = _scheduleData$pages$3.body) === null || _scheduleData$pages$4 === void 0 ? void 0 : (_scheduleData$pages$5 = _scheduleData$pages$4.content) === null || _scheduleData$pages$5 === void 0 ? void 0 : _scheduleData$pages$5.map(function (scheduleItem, scheduleIndex) {
        var _scheduleItem$animato, _scheduleItem$animato2;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (0,clsx_m/* default */.Z)((radio_view_module_default()).live_track, (radio_view_module_default()).schedule_item),
          tabIndex: 0,
          "data-navigate-row": true,
          children: [scheduleItem !== null && scheduleItem !== void 0 && scheduleItem.image || radio !== null && radio !== void 0 && radio.logo || radio !== null && radio !== void 0 && radio.smallLogo ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: (radio_view_module_default()).live_track_logo,
            src: (scheduleItem === null || scheduleItem === void 0 ? void 0 : scheduleItem.image) || (radio === null || radio === void 0 ? void 0 : radio.logo) || (radio === null || radio === void 0 ? void 0 : radio.smallLogo)
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((radio_view_module_default()).no_image, (radio_view_module_default()).live_track_logo),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (radio_view_module_default()).live_track_body,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              children: scheduleItem === null || scheduleItem === void 0 ? void 0 : scheduleItem.name
            }), scheduleItem !== null && scheduleItem !== void 0 && (_scheduleItem$animato = scheduleItem.animators) !== null && _scheduleItem$animato !== void 0 && _scheduleItem$animato.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              children: scheduleItem === null || scheduleItem === void 0 ? void 0 : (_scheduleItem$animato2 = scheduleItem.animators) === null || _scheduleItem$animato2 === void 0 ? void 0 : _scheduleItem$animato2.map(function (animator, animatorIndex) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: animator === null || animator === void 0 ? void 0 : animator.name
                  }, "animator-".concat(animatorIndex)), animatorIndex !== scheduleItem.animators.length - 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: ",\xA0"
                  }) : null]
                });
              })
            }) : null, scheduleItem.start && scheduleItem.end && /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
              children: formatScheduleTime(scheduleItem.start, scheduleItem.end)
            })]
          })]
        }, "schedule-item-".concat(scheduleIndex));
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (radio_view_module_default()).no_data,
      children: t("radio.no-program")
    }) : null, activeTab === RadioTabs.Podcasts ? radioPodcastsData !== null && radioPodcastsData !== void 0 && (_radioPodcastsData$pa = radioPodcastsData.pages) !== null && _radioPodcastsData$pa !== void 0 && _radioPodcastsData$pa.length && radioPodcastsData !== null && radioPodcastsData !== void 0 && (_radioPodcastsData$pa2 = radioPodcastsData.pages[0]) !== null && _radioPodcastsData$pa2 !== void 0 && (_radioPodcastsData$pa3 = _radioPodcastsData$pa2.data) !== null && _radioPodcastsData$pa3 !== void 0 && (_radioPodcastsData$pa4 = _radioPodcastsData$pa3.body) !== null && _radioPodcastsData$pa4 !== void 0 && (_radioPodcastsData$pa5 = _radioPodcastsData$pa4.content) !== null && _radioPodcastsData$pa5 !== void 0 && _radioPodcastsData$pa5.length ? radioPodcastsLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (radio_view_module_default()).content_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: (radio_view_module_default()).details_header,
        children: t("tabs.podcasts")
      }), radioPodcastsData === null || radioPodcastsData === void 0 ? void 0 : (_radioPodcastsData$pa6 = radioPodcastsData.pages[0]) === null || _radioPodcastsData$pa6 === void 0 ? void 0 : (_radioPodcastsData$pa7 = _radioPodcastsData$pa6.data) === null || _radioPodcastsData$pa7 === void 0 ? void 0 : (_radioPodcastsData$pa8 = _radioPodcastsData$pa7.body) === null || _radioPodcastsData$pa8 === void 0 ? void 0 : (_radioPodcastsData$pa9 = _radioPodcastsData$pa8.content) === null || _radioPodcastsData$pa9 === void 0 ? void 0 : _radioPodcastsData$pa9.map(function (radioPodcast, podcastIndex) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/".concat(radioPodcast.permalink),
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (radio_view_module_default()).live_track,
              tabIndex: 0,
              "data-navigate-item": true,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (radio_view_module_default()).live_track_logo,
                src: (radioPodcast === null || radioPodcast === void 0 ? void 0 : radioPodcast.logo) || (radioPodcast === null || radioPodcast === void 0 ? void 0 : radioPodcast.smallLogo),
                alt: radioPodcast.name
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (radio_view_module_default()).live_track_body,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: radioPodcast === null || radioPodcast === void 0 ? void 0 : radioPodcast.name
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                  children: radioPodcast === null || radioPodcast === void 0 ? void 0 : radioPodcast.description
                })]
              })]
            }, "podcast-item-".concat(podcastIndex))
          })
        }, "podcast-item-".concat(radioPodcast.permalink, "-").concat(podcastIndex));
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (radio_view_module_default()).no_data,
      children: t("radio.no-podcasts")
    }) : null]
  });
};
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./app/components/back-button/back-button.component.tsx
var back_button_component = __webpack_require__(56227);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./app/utils/string.ts
var string = __webpack_require__(62735);
;// CONCATENATED MODULE: ./pages/radios/[...permalink].tsx

















var __N_SSG = true;
function RadioPage(_ref) {
  var initialData = _ref.initialData;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: router.isFallback ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (radio_details_module_default()).wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("loader", (radio_details_module_default()).loader),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(RadioPageContent, {
      initialData: initialData
    })
  });
}

var RadioPageContent = function RadioPageContent(_ref2) {
  var _initialData$tags;

  var initialData = _ref2.initialData;
  var router = (0,next_router.useRouter)();
  var permalink = router.query.permalink;
  var parsedPermalink = (permalink === null || permalink === void 0 ? void 0 : permalink.join("/")) || "";
  var t = (0,lang/* useTranslate */.q)();
  var goBack = (0,navigation_hook/* useNavigateBack */.ub)();
  (0,go_back_hook/* useGoBackHistory */.J)("RADIOS/PERMALINK");
  var radioName = initialData.name;
  var radioDescription = initialData.description || "";
  var pageTags = (_initialData$tags = initialData.tags) === null || _initialData$tags === void 0 ? void 0 : _initialData$tags.filter(function (tag) {
    return tag.tagType !== "audioads";
  }).map(function (tag) {
    return tag.name;
  }).join(", ");
  var openGraphImages = initialData.logo ? [{
    url: initialData.logo,
    alt: radioName
  }] : [];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: pageTags && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: pageTags
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t("seo_title_radio", {
        var1: radioName
      }),
      titleTemplate: "%s",
      description: "".concat(t("seo_description_radio", {
        var1: radioName,
        var2: (0,string/* truncateString */.a)(radioDescription, 160)
      })).trim(),
      languageAlternates: [].concat((0,toConsumableArray/* default */.Z)((router.locales || []).filter(function (locale) {
        return locale !== "defaultLang";
      }).map(function (locale) {
        return {
          hrefLang: locale,
          href: "https://www.radioline.co/".concat(locale, "/radios/").concat(parsedPermalink)
        };
      })), [{
        href: "https://www.radioline.co/en/radios/".concat(parsedPermalink),
        hrefLang: "x-default"
      }]),
      canonical: router.locale !== "defaultLang" ? "https://www.radioline.co/".concat(router.locale, "/radios/").concat(parsedPermalink) : "https://www.radioline.co/en/radios/".concat(parsedPermalink),
      openGraph: {
        images: openGraphImages
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
      onClick: goBack
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (radio_details_module_default()).wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioView, {
        radio: initialData
      })
    })]
  });
};

/***/ }),

/***/ 74221:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/radios/[...permalink]",
      function () {
        return __webpack_require__(89404);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","back":"back-button_back__KRknK","forgot_button":"back-button_forgot_button__Jmz7Z","wrapper":"back-button_wrapper__cmCKR","absolute":"back-button_absolute__HllSl"};

/***/ }),

/***/ 32144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","action_button":"radio-view_action_button__r1IJc","expander":"radio-view_expander__sEzHq","tab":"radio-view_tab__dIuO4","live_track":"radio-view_live_track__DRzRn","wrapper":"radio-view_wrapper__HO9HH","website_button":"radio-view_website_button__p0fLU","podcast_cover":"radio-view_podcast_cover__h9jLx","no_image":"radio-view_no_image__1rKaH","podcast_details":"radio-view_podcast_details__0uimE","buttons_wrapper":"radio-view_buttons_wrapper__DwcIk","play_button":"radio-view_play_button__GOYYU","favorites_button":"radio-view_favorites_button__EtBIL","podcast_description":"radio-view_podcast_description___Av64","podcast_description_container":"radio-view_podcast_description_container__CuU4_","expandable":"radio-view_expandable__jbycB","description":"radio-view_description__UEQwj","expanded":"radio-view_expanded__yf3jS","description_container":"radio-view_description_container__hSyww","open":"radio-view_open__MloND","content_wrapper":"radio-view_content_wrapper__fcOsB","details_header":"radio-view_details_header__PLdEd","responsive":"radio-view_responsive__Jblpp","schedule_item":"radio-view_schedule_item__9NEuJ","live_track_logo":"radio-view_live_track_logo__T2caa","live_track_body":"radio-view_live_track_body__ZSgXg","spotify_add":"radio-view_spotify_add__wY2Ob","tabs":"radio-view_tabs__YvL3g","tabs_wrapper":"radio-view_tabs_wrapper___m8Z8","active":"radio-view_active__yIClm","no_data":"radio-view_no_data__flECP"};

/***/ }),

/***/ 66795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"radio-details_wrapper__MiypL","loader":"radio-details_loader__jIjdO","header":"radio-details_header__tFBdD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,7573,5413,9774,2888,179], function() { return __webpack_exec__(74221); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);